import { Injectable } from '@angular/core';
import {Group, Restaurant} from '../models/restaurant.model';

@Injectable({
  providedIn: 'root'
})
export class FormatStyleService {
  private readonly defaultBrandColor = '#4298B5';
  private readonly defaultSecondaryBrandColor = '#53565A';
  private readonly defaultBackgroundColor = '#FFFFFF';
  private readonly defaultSecondaryBackgroundColor = '#D38235';
  private readonly defaultBorderColor = '#E5E7EB';
  private readonly defaultPrimaryTextColor = '#3B363A';
  private readonly defaultSecondaryTetColor = '#3B363A';
  private readonly defaultWarningTextColor = '#EB6E57';

  constructor() { }

  public getBrandColor(isGroup?: boolean, group?: Group, restaurant?: Restaurant): string {
    if (isGroup) return group.brandColor || this.defaultBrandColor;
    return restaurant ? restaurant.brandColor : this.defaultBrandColor;
  }

  public getBackgroundColor(isGroup: boolean, group: Group, restaurant: Restaurant): string {
    return (isGroup ? group.backgroundColor : restaurant.backgroundColor) || this.defaultBackgroundColor;
  }

  public getBorderColor(isGroup: boolean, group: Group, restaurant: Restaurant): string {
    return (isGroup ? group.borderColor : restaurant.borderColor) || this.defaultBorderColor;
  }

  public getPrimaryTextColor(isGroup: boolean, group: Group, restaurant: Restaurant): string {
    return (isGroup ? group.primaryTextColor : restaurant.primaryTextColor) || this.defaultPrimaryTextColor;
  }

  public setGlobalFont(font: string): void {
    document.documentElement.style.setProperty('--font', `${font}, sans-serif`);
  }

  public setGlobalBrandColor(brandColor: string): void {
    const globalBrandColor = brandColor || this.defaultBrandColor;
    document.documentElement.style.setProperty('--brand-color', globalBrandColor);
    document.documentElement.style.setProperty('--brand-color-opacity', this.hexToRgbA(globalBrandColor));
    document.documentElement.style.setProperty('--brand-color-tint', this.shadeColor(globalBrandColor, -30));
  }

   public setGlobalSecondaryBrandColor(brandColor: string): void {
    const globalSecondaryBrandColor = brandColor || this.defaultSecondaryBrandColor;
    document.documentElement.style.setProperty('--secondary-brand-color', globalSecondaryBrandColor);
  }

  public setGlobalBackgroundColor(backgroundColor: string): void {
    const globalBackgroundColor = backgroundColor || this.defaultBackgroundColor;
    document.documentElement.style.setProperty('--background-color', globalBackgroundColor);
    document.documentElement.style.setProperty('--background-color-opacity', this.hexToRgbA(globalBackgroundColor));
    document.documentElement.style.setProperty('--background-color-no-opacity', this.hexToRgbA(globalBackgroundColor, 0));
    document.documentElement.style.setProperty('--background-color-tint', this.shadeColor(globalBackgroundColor, -30));
  }

  public setGlobalSecondBackgroundColor(backgroundColor: string): void {
    const globalSecondaryBackgroundColor = backgroundColor || this.defaultSecondaryBackgroundColor;
    document.documentElement.style.setProperty('--secondary-background-color', globalSecondaryBackgroundColor);
  }

  public setGlobalBorderColor(borderColor: string): void {
    const globalBorderColor = borderColor || this.defaultBorderColor;
    document.documentElement.style.setProperty('--border-color-store', globalBorderColor);
    document.documentElement.style.setProperty('--border-color-opacity', this.hexToRgbA(globalBorderColor));
    document.documentElement.style.setProperty('--border-color-tint', this.shadeColor(globalBorderColor, -30));
  }

  public setGlobalPrimaryTextColor(primaryTextColor: string): void {
    const globalPrimaryTextColor = primaryTextColor || this.defaultPrimaryTextColor;
    document.documentElement.style.setProperty('--primary-text-color', globalPrimaryTextColor);
    document.documentElement.style.setProperty('--primary-text-color-opacity', this.hexToRgbA(globalPrimaryTextColor));
    document.documentElement.style.setProperty('--primary-text-color-tint', this.shadeColor(globalPrimaryTextColor, -30));
  }

  public setGlobalSecondaryTextColor(secondaryTextColor: string): void {
    const globalSecondaryTextColor = secondaryTextColor || this.defaultSecondaryTetColor;
    document.documentElement.style.setProperty('--secondary-text-color', globalSecondaryTextColor);
  }

  public setGlobalWarningTextColor(warningTextColor: string): void {
    const globalWarningTextColor = warningTextColor || this.defaultWarningTextColor;
    document.documentElement.style.setProperty('--color-warning-scc', globalWarningTextColor);
  }

  public hexToRgbA(hex: string, opacity: number = 0.2): string {
    let color;
    if (hex) {
      color = hex.substring(1).split('');
      if (color.length === 3) {
        color = [color[0], color[0], color[1], color[1], color[2], color[2]];
      }
      color = '0x' + color.join('');
      // tslint:disable-next-line:no-bitwise
      return `rgba(${[(color >> 16) & 255, (color >> 8) & 255, color & 255]}, ${opacity})`;
    }
  }

  public shadeColor(color: string, percent: number): string {
    if (color) {
      let R = parseInt(color.substring(1, 3), 16);
      let G = parseInt(color.substring(3, 5), 16);
      let B = parseInt(color.substring(5, 7), 16);

      R = parseInt(String(R * (100 + percent) / 100), 10);
      G = parseInt(String(G * (100 + percent) / 100), 10);
      B = parseInt(String(B * (100 + percent) / 100), 10);

      R = (R < 255) ? R : 255;
      G = (G < 255) ? G : 255;
      B = (B < 255) ? B : 255;

      const RR = ((R.toString(16).length === 1) ? '0' + R.toString(16) : R.toString(16));
      const GG = ((G.toString(16).length === 1) ? '0' + G.toString(16) : G.toString(16));
      const BB = ((B.toString(16).length === 1) ? '0' + B.toString(16) : B.toString(16));

      return '#' + RR + GG + BB;
    }
  }
}
